import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { TransferDto } from '../types';

export const useCreateTransferFromReceipt = (receiptId: string) => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<TransferDto, Error, void>({
    mutationFn: () =>
      apiClient.post(`/v1/projects/${projectId}/receipts/${receiptId}/create-transfer`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['receipt', receiptId] });
      queryClient.invalidateQueries({ queryKey: ['receipts', projectId] });
      queryClient.invalidateQueries({ queryKey: ['receipt-transfer-suggestions', receiptId] });
      queryClient.invalidateQueries({ queryKey: ['transfers', projectId] });
    },
  });
};
